import KwaiLog from '@kibt/weblogger';
import 'intersection-observer';

import { type ShowOptions } from '@ks/weblogger';

import { getQueryParams } from './query';

const query = getQueryParams();


export const logger = new KwaiLog({
    env: process.env.VUE_APP_LOG_ENV || 'production',
    radar: {
        projectId: '982845018r',
        sampling: 1,
        ignoreList: [
            'https://tx-pro-origin-hlspull.kwai.net/livecloud',
            'https://tx-pro-origin-hlspull.snackvideo.in/livecloud',
            'https://ws-pro-origin-hlspull.kwai.net/livecloud',
            'https://ws-pro-origin-hlspull.snackvideo.in/livecloud',
            'https://ali-pro-origin-hlspull.kwai.net/livecloud',
            'https://ali-pro-origin-hlspull.snackvideo.in/livecloud',
            'http://tx-pro-origin-hlspull.kwai.net/livecloud',
            'http://tx-pro-origin-hlspull.snackvideo.in/livecloud',
            'http://ws-pro-origin-hlspull.kwai.net/livecloud',
            'http://ws-pro-origin-hlspull.snackvideo.in/livecloud',
            'http://ali-pro-origin-hlspull.kwai.net/livecloud',
            'http://ali-pro-origin-hlspull.snackvideo.in/livecloud',
        ],
    },
});

const originShow = logger.sendShow;
const originClick = logger.sendClick;

const cached = {

} as Record<string, boolean>;

logger.sendShow = function sendShow(params: ShowOptions & { once: boolean } | string) {
    if (typeof params !== 'string' && params.once) {
        const str = JSON.stringify(params);
        if (cached[str]) {
            return;
        }
        cached[str] = true;

    }
    if (typeof params === 'string') {
        originShow.call(logger, { action: params, params: { ...query} });
    } else {
        originShow.call(logger, { ...params, params: { ...query, ...params.params } });
    }
};

logger.sendClick = function sendClick(params: ShowOptions | string) {
    if (typeof params === 'string') {
        originClick.call(logger, { action: params, params: { ...query } });
    } else {
        originClick.call(logger, { ...params, params: { ...query, ...params.params } });
    }
};

export default logger;



export type customRadarOpts = { lcp?: boolean };

export const createLogger = (opts?: customRadarOpts) => {
    // eslint-disable-next-line no-param-reassign
    opts = opts ?? {};
    return new KwaiLog({
        env: process.env.VUE_APP_LOG_ENV || 'production',
        radar: {
            projectId: '982845018r',
            sampling: 1,
            resourceSampling: 1,
            ...opts,
        },
    });
};

export const sendCdnLog = (values: Record<string, unknown>) => {
    logger.sendRadarLog({
        name: values.type as string,
        category: 'kwai-log-live-lang-hot-update',
        event_type: 'custom',
        extra_info: JSON.stringify(values),
    });
};



export enum LogTypeEnum {
    CUSTOM = 'custom', // 默认上报类型
    PV = 'pv',
    SHOW = 'show',
    CLICK = 'click',
    API_ERROR= 'api_error',
}

type CustomOptionsType = {
    event_type?: LogTypeEnum,
    name: string,
    result_type?: string | number;
    extra_info?: string;
}

// sendLiveCustomLog({
//     event_type: LogTypeEnum.PV,
//     name: 'HOSTCENTER',
//     result_type: 1,
//     extra_info: 'test',
// });

/**
 * name命名规则 页面名(-子页面名-交互名)
 * 列表无数据，例如 WONDERFUL-LIST-EMPTY
 * 按钮点击，例如 PAYTASK-BTN
 * 接口异常，例如 TOPUP-ERRORs
 */

// 业务核心埋点
export const sendLiveCustomLog = (options: CustomOptionsType) => {
    const data = {
        ...options,
        event_type: typeof options.event_type === 'undefined' ? LogTypeEnum.CUSTOM : options.event_type,
        result_type: typeof options.result_type === 'undefined' ? '' : `${options.result_type}`,
        category: 'kwai-log-live-midyear',
    };
    logger.sendRadarLog(data);
};

// 接口异常或res.result不为1等
export const sendLiveErrorlog = (name: string) => {
    sendLiveCustomLog({
        name,
        event_type: LogTypeEnum.API_ERROR,
    });
};

// 按钮点击
export const sendLiveClicklog = (name: string) => {
    sendLiveCustomLog({
        name,
        event_type: LogTypeEnum.CLICK,
    });
};
